import React, { Component } from 'react';
import { Button } from 'antd';
import { Package, Plus } from 'lucide-react';
import Inherit from '../../core/inherit';
import withNavigate from '../../core/withNavigate';
import ProductsController from './products.controller';
import { Layout, TableSkeleton, PageHeader } from '../common';
import { ProductDrawer, ProductsActions, ProductsTable } from './elements';

export class ShelfProducts extends Inherit(ProductsController, Component) {
    state = {
        loading: true,
        products: [],
        rows: [],
        isOpen: false,
        selectedProduct: null
    };

    render() {
        const { contextHolder } = this.props;
        const { loading, rows, isOpen, selectedProduct } = this.state;

        return (
            <Layout current="products">
                {contextHolder}
                <PageHeader
                    icon={<Package />}
                    title="Productos"
                    description="Gestiona el catálogo central de productos"
                    actions={
                        !loading && (
                            <Button type="primary" icon={<Plus />} onClick={this.openCreateDrawer.bind(this)}>
                                Nuevo producto
                            </Button>
                        )
                    }
                />

                {loading ? (
                    <TableSkeleton rows={10} columns={5} />
                ) : (
                    <>
                        <section className="shelf-card overflow-hidden">
                            <div className="border-b border-surface-100 px-5 py-4">
                                <ProductsActions onSearch={(term) => this.searchProducts(term)} total={rows?.length} />
                            </div>
                            <ProductsTable
                                rows={rows}
                                loading={loading}
                                onEdit={this.showEditDrawer.bind(this)}
                                onToggleActive={this.toggleProductActive.bind(this)}
                            />
                        </section>
                        <ProductDrawer
                            isOpen={isOpen}
                            setIsOpen={this.setIsOpen.bind(this)}
                            selectedProduct={selectedProduct}
                            loading={loading}
                            onSubmit={this.createOrUpdateProduct.bind(this)}
                            onUploadImage={this.uploadProductImage.bind(this)}
                            searchBarcodes={this.searchBarcodes.bind(this)}
                            categoryOptions={this.categoryOptions}
                        />
                    </>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfProducts);
